import { render, staticRenderFns } from "./visitors-access-modal.vue?vue&type=template&id=64c5737c&"
import script from "./visitors-access-modal.vue?vue&type=script&lang=ts&"
export * from "./visitors-access-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports